import React from "react";

export const FullButton = ({
                               buttonText,
                               activeColor,
                               buttonTextColor,
                               inactiveColor,
                               handleOnPress,
                               active,
                               height,
                               width,
                               customCursor = "pointer",
                               isDisable = false,
                               borderColor = "none"
                           }) => {
    return (
        <>
            <button
                style={{
                    borderRadius: "10px",
                    height: height,
                    width: width,
                    color: buttonTextColor,
                    fontWeight: 600,
                    fontFamily: "Inter, Arial, sans-serif",
                    backgroundColor: active ? activeColor : inactiveColor,
                    cursor: isDisable ? "not-allowed" : customCursor,
                    border: borderColor,
                }}
                disabled={isDisable}
                onClick={handleOnPress}
            >
                {buttonText}
            </button>
        </>
    );
};
